// src/store/modules/cookie.js
import Cookies from 'js-cookie';
import CookieManager from '@/components/CookieConsent/cookie-manager';
import store from '@/store';

const state = {
  consent: CookieManager.getConsent() || {
    necessary: true,
    performance: false,
    functional: false,
    targeting: false
  },
  showBanner: false,
  showPreferences: false,
  cookieCategories: CookieManager.cookieCategories,
  cookieDetails: CookieManager.cookieDetails
};

const getters = {
  hasConsent: state => {
    return state.consent && (state.consent.performance || state.consent.functional || state.consent.targeting);
  },
  isBannerVisible: state => {
    return state.showBanner && !state.consent;
  },
  getCategoryById: state => categoryId => {
    return state.cookieCategories[categoryId] || null;
  },
  getCookiesByCategory: state => categoryId => {
    return state.cookieDetails[categoryId] || [];
  }
};

const mutations = {
  SET_CONSENT(state, consent) {
    state.consent = consent;
    CookieManager.saveConsent(consent);
    const sidebarStatus = Cookies.get('sidebarStatus');
    // 判断consent中的functional，如果为false，则设置为1
    if (!consent?.functional && String(sidebarStatus) === '0') {
      Cookies.set('sidebarStatus', 1);
      // 触发侧边栏切换
      store.dispatch('settings/toggleSideBar');
    }
  },
  SET_SHOW_BANNER(state, show) {
    state.showBanner = show;
  },
  SET_SHOW_PREFERENCES(state, show) {
    state.showPreferences = show;
  },
  UPDATE_CATEGORY_PREFERENCE(state, { category, value }) {
    state.consent[category] = value;
  }
};

const actions = {
  initCookieConsent({ commit, dispatch }) {
    const shouldShow = CookieManager.shouldShowBanner();
    commit('SET_SHOW_BANNER', shouldShow);
    
    const savedConsent = CookieManager.getConsent();
    if (savedConsent) {
      commit('SET_CONSENT', savedConsent);
    }
  },

  acceptAll({ commit }) {
    const newConsent = {
      necessary: true,
      performance: true,
      functional: true,
      targeting: true
    };
    commit('SET_CONSENT', newConsent);
    commit('SET_SHOW_BANNER', false);
    commit('SET_SHOW_PREFERENCES', false);
  },

  acceptNecessaryOnly({ commit }) {
    const newConsent = {
      necessary: true,
      performance: false,
      functional: false,
      targeting: false
    };
    commit('SET_CONSENT', newConsent);
    commit('SET_SHOW_BANNER', false);
    commit('SET_SHOW_PREFERENCES', false);
  },

  savePreferences({ commit, state }) {
    commit('SET_CONSENT', { ...state.consent });
    commit('SET_SHOW_BANNER', false);
    commit('SET_SHOW_PREFERENCES', false);
  },

  openPreferences({ commit }) {
    commit('SET_SHOW_PREFERENCES', true);
  },

  closePreferences({ commit }) {
    commit('SET_SHOW_PREFERENCES', false);
  },

  updateCategoryPreference({ commit }, payload) {
    commit('UPDATE_CATEGORY_PREFERENCE', payload);
  },

  // 关闭所有 cookie 相关弹窗
  closeAllCookieModals({ commit }) {
    commit('SET_SHOW_BANNER', false);
    commit('SET_SHOW_PREFERENCES', false);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
